// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider-3Dcan"};